<template>
	<div class="flex items-center">
    <div
      class="rounded-full bg-smoke-100 w-10 h-10 cursor-pointer flex items-center mr-3"
      @click="prevPage()"
    >
      <img src="@/assets/icons/chevronLeft.svg" class="mx-auto">
    </div>
    <div
      class="rounded-full bg-smoke-100 w-16 h-10 flex items-center justify-center border border-dark-b"
    >
      {{ currentPage }}
    </div>
    <span class="px-4">
      of <div class="w-5 inline-block">{{ totalPages }}</div>
    </span>
    <div
      class="rounded-full bg-smoke-100 w-10 h-10 cursor-pointer flex items-center"
      @click="nextPage()"
    >
      <img src="@/assets/icons/chevronRight.svg" class="mx-auto">
    </div>
  </div>
</template>
<script>
export default {
	name: 'Pagination',
	props: {
		totalPages: {
			type: Number
		},
		currentPage: {
			type: Number,
			default: 1
		}
	},
	methods: {
		nextPage() {
			if (this.currentPage !== this.totalPages) {
				this.changePage(this.currentPage + 1)
			}
		},
		prevPage() {
			if (this.currentPage !== 1) {
				this.changePage(this.currentPage - 1)
			}
		},
		changePage(val) {
			this.$emit('changePage', val)
		}
	}
}
</script>